import React from "react";
import { gql } from "@apollo/client";

import { Typography } from "@mui/material";
import { CreditCard as PaymentIntentIcon } from "mdi-material-ui";

const Icon = () => <PaymentIntentIcon />;

const Title = () => <span>Carte enregistrée</span>;

const Content = ({ orderEvent }) => (
  <>
    <Typography>
      <strong>customerId</strong> : {orderEvent.stripeCustomerId}
    </Typography>
    <Typography>
      <strong>paymentMethodId</strong> : {orderEvent.stripePaymentMethodId}
    </Typography>
  </>
);

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_PaymentIntentEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_PaymentIntent {
        stripeCustomerId
        stripePaymentMethodId
      }
    }
  `,
};

const Event = { Icon, Title, Content, fragments };

export default Event;
